<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
        [filterDelay]="0"
        [loading]="amenityService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true"
        [value]="amenityService.amenities">

        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Amenidades
              </div>
              <div class="col-8 text-end">
                <button 
                  (click)="open()" 
                  class="btn btn-success rounded-circle me-2">
                  <i class="material-icons mt-1">add</i>
                </button>
                <button 
                  (click)="amenityService.getAll(neighborhoodId!)" 
                  class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th></th>

            <th pSortableColumn="name">
              Nombre
              <p-sortIcon field="name"></p-sortIcon>
              <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="capacity">
              Aforo
              <p-sortIcon field="capacity"></p-sortIcon>
              <p-columnFilter type="number" field="capacity" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="anticipations">
              Ventana
              <p-sortIcon field="anticipations"></p-sortIcon>
              <p-columnFilter type="number" field="anticipations" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="status">
              Activo
              <p-sortIcon field="status"></p-sortIcon>
              <p-columnFilter type="boolean" field="status" display="menu"></p-columnFilter>
            </th>

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-amenity>
          <tr class="p-selectable-row">
            <td>
              @if(amenity.image) {
                <div 
                  class="bg-center"
                  style="width: 5vh; height: 5vh;"
                  [ngStyle]="{
                    'background-image': 'url(' + amenity.image.urlFile + ')'
                  }">
                </div>
              }
            </td>

            <td>
              <span class="p-column-title">Nombre</span>
              {{ amenity.name }}
            </td>

            <td>
              <span class="p-column-title">Aforo</span>
              {{ amenity.capacity }}
            </td>
            
            <td>
              <span class="p-column-title">Ventana</span>
              {{ amenity.anticipations }} hrs
            </td>

            <td>
              <span class="p-column-title">Activo</span>
              <p-inputSwitch
                (onChange)="update(amenity)"
                [(ngModel)]="amenity.status">
              </p-inputSwitch>
            </td>

            <td>

              @if(amenity.regulation) {
                <a
                  [href]="amenity.regulation.urlFile"
                  target="_blank"
                  class="btn btn-sm btn-light rounded-circle me-2"
                  placement="top"
                  ngbTooltip="Ver reglamento">
                  <i class="material-icons mt-1">description</i>
                </a>
              }

              <button
                (click)="createBooking(amenity)"
                class="btn btn-sm btn-light rounded-circle me-2"
                placement="top"
                ngbTooltip="Nueva reservación">
                <i class="material-icons mt-1">event</i>
              </button>

              <button
                (click)="openTimetable(amenity)"
                class="btn btn-sm btn-light rounded-circle me-2"
                placement="top"
                ngbTooltip="Horarios">
                <i class="material-icons mt-1">edit_calendar</i>
              </button>

              <button
                (click)="open(amenity)"
                class="btn btn-sm btn-light rounded-circle me-2"
                placement="top"
                ngbTooltip="Editar">
                <i class="material-icons mt-1">edit</i>
              </button>

              <button
                (click)="delete(amenity)"
                class="btn btn-sm btn-danger rounded-circle"
                placement="top"
                ngbTooltip="Borrar">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
